module.exports = __webpack_public_path__ + "img/down_new_android.77ba19f3.png";